import { useRef, useState } from 'react'
import { addBusinessDays, formatDate } from '../../helpers/formatDate'
import { useShopifyMetadata } from '../../hooks/useShopifyMetadata'
import { PlusAccordion } from '../../icons/PlusAccordion'
import { MinusAccordion } from '../../icons/MinusAccordion'
import cn from 'classnames'

export const Description = () => {
  const shopifyMetadata = useShopifyMetadata()
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState('')
  const isBespokeTag = (shopifyMetadata?.tags || []).includes('Production Type_Bespoke') || false
  const productionTimeTag = (shopifyMetadata?.tags || []).find((tag) => tag.includes('Production Time')) || null

  if (!shopifyMetadata || !shopifyMetadata.accordions) return <></>

  return (
    <div className="Product__Info px-5 m-0 font-calibre w-full max-w-none">
      <div className="flex flex-col border-b border-ink/10 border-solid">
        <div>
          {isBespokeTag && shopifyMetadata?.bespokeText && <p className="mb-6 font-calibre">{shopifyMetadata?.bespokeText}</p>}
          {productionTimeTag && <CalculateProductionTime productionTimeTag={productionTimeTag} />}
        </div>
        {shopifyMetadata.accordions.map((accordion, i) => (
          <DescriptionAccordion
            index={i}
            key={i}
            title={accordion.title}
            description={accordion.description}
            currentOpenAccordion={currentOpenAccordion}
            setCurrentOpenAccordion={setCurrentOpenAccordion}
          />
        ))}
      </div>
    </div>
  )
}

const DescriptionAccordion = ({
  index,
  title,
  description,
  currentOpenAccordion,
  setCurrentOpenAccordion
}: {
  index: number
  title: string
  description: string
  currentOpenAccordion: string
  setCurrentOpenAccordion: React.Dispatch<React.SetStateAction<string>>
}) => {
  const bodyRef = useRef<HTMLDivElement>(null)

  if (!title || !description) return <></>

  return (
    <div className="flex-1">
      <button
        onClick={() => setCurrentOpenAccordion(title === currentOpenAccordion ? '' : title)}
        className={cn('flex items-center accordion-item__heading Button backdrop-opacity-0 text-sm-b hover:text-ink',
        index > 0 ? ' border-t border-ink/10 border-solid' : '',
        title === currentOpenAccordion ? 'active' : '')}
      >
        <span className="accordion-item__title">{title}</span>
        <PlusAccordion className="accordion-item__icon-open block [.active_&]:hidden"/>
        <MinusAccordion className="accordion-item__icon-close hidden [.active_&]:block"/>
      </button>

      <div
        ref={bodyRef}
        className="Collapsible__Content py-0 builder-accordion overflow-hidden transition-all font-calibre [&_p]:font-calibre"
        style={{ maxHeight: title === currentOpenAccordion ? bodyRef.current?.scrollHeight : 0 }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  )
}

const CalculateProductionTime = ({ productionTimeTag }: { productionTimeTag: string }) => {
  // expected productionTimeTag format: "Production Time_10 business days"
  const currentDate = new Date()
  // get second part of productionTimeTag
  const productionTime = productionTimeTag.split('_')
  // get number of productionTimeTag
  const productionTimeNumber = productionTime[1].split(' ')[0]
  const numberOfBusinessDays = Number(productionTimeNumber)
  const estimatedDispatchDate = addBusinessDays(currentDate, numberOfBusinessDays)
  const formattedDate = formatDate(estimatedDispatchDate)
  return <p className="mb-6 font-calibre">Estimated dispatch on {formattedDate}</p>
}
